// ExternalCompanyLeaves.jsx
// 외부 회사별 연차 관리 페이지 (/admin/ext/:code/leaves)
// syncLeavesEndpoint 는 외부직원 공용 시트 동기화 엔드포인트를 재사용한다.

import React from 'react';
import { useParams } from 'react-router-dom';
import { useExtCompany, ExtCompanyFallback } from './useExtCompany';
import LeaveManagement from './LeaveManagement';

const CHECK = { key: 'leave', label: '연차 관리', mode: 'truthy' };

export default function ExternalCompanyLeaves() {
  const { code } = useParams();
  const { company, loading, error } = useExtCompany(code, CHECK);
  if (!company) return <ExtCompanyFallback loading={loading} error={error} />;

  return (
    <LeaveManagement
      pageTitle="연차 관리"
      apiBase={`/api/admin/ext/${company.code}/leaves`}
      syncLeavesEndpoint="/api/admin/sheets/sync/external-leaves"
      settingsApiPath={`/api/admin/ext/${company.code}/attendance-time-settings`}
    />
  );
}
